import { useEffect, useState } from 'react';

type ImageSize = { width: number; height: number };

export const useImageSizes = (srcs: string[]): Map<string, ImageSize> => {
  const [sizes, setSizes] = useState<Map<string, ImageSize>>(new Map());

  useEffect(() => {
    const newSizes = new Map<string, ImageSize>();
    let isCancelled = false;

    Promise.all(
      srcs.map(
        src =>
          new Promise<void>(resolve => {
            const img = new Image();
            img.onload = () => {
              if (!isCancelled) {
                newSizes.set(src, {
                  width: img.naturalWidth,
                  height: img.naturalHeight,
                });
              }
              resolve();
            };
            img.onerror = () => resolve();
            img.src = src;
          })
      )
    ).then(() => {
      if (!isCancelled) {
        setSizes(newSizes);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [JSON.stringify(srcs)]);

  return sizes;
};
